<div
    *ngIf="showOverlay"
    class="agpr-dialogOverlay"
    [ngStyle]="{'z-index': zIndex}"
></div>
<div
    [id]="id"
    class="agpr-iframeDialog"
    [ngStyle]="{'z-index': zIndex + 1}"
    role="dialog"
    [attr.aria-modal]="true"
    [attr.aria-labelledby]="id + '.dialogTitle'"
    cdkTrapFocus
    [cdkTrapFocusAutoCapture]="true"
>
    <div class="agpr-iframeDialog-header">
        <h2 [id]="id + '.dialogTitle'" class="agpr-iframeDialog-heading" tabindex="0">
            {{ heading | localize }}
        </h2>
        <div class="agpr-iframeDialog-actions">
            <button
                *ngIf="showClose"
                [id]="id + '.close'"
                [attr.aria-label]="'close' | localize"
                class="agpr-iframeDialog-close"
                (click)="cancel()"
            >
                <span class="fa fa-duotone fa-close" aria-hidden="true"></span>
            </button>
        </div>
    </div>
    <div
        class="agpr-iframeDialog-content"
        [ngStyle]="{width: frameWidth, maxWidth: maxWidth, maxHeight: frameHeight, overflow: 'auto'}"
    >
        <iframe
            #iframe
            allowfullscreen
            [attr.allow]="allowAutoplay ? 'autoplay' : null"
            [attr.muted]="allowAutoplay ? 'muted' : null"
            class="agpr-iframeDialog-iframe"
            [ngStyle]="{
                height: frameHeight ? frameHeight : '80vh',
                width: frameWidth ? frameWidth : '90vw',
                minHeight: minHeight,
                minWidth: minWidth
            }"
            [src]="_url?.href | agprBypassURLSecurity"
            frameborder="0"
            [title]="heading | localize"
        >
        </iframe>
    </div>
</div>
